export default "__VITE_ASSET__8c1231ae__"